const email = {
	name: 'E-Mail Adresse | E-Mail Adressen',
	icon: '',
	fields: {
		email: 'E-Mail Adresse',
		communication_type: 'Kommunikationsart',
		description: '@:common.description',
		typeNotFound: 'Typ nicht gefunden',
	},
}

export default email
